<template>
  <b-row class="summary2 no-gutters">
    <b-col class="tool-border" cols="12">
      <b-col class="reduce-padding" cols="12">
        <wlpHeader :pageTitle="pageTitle"></wlpHeader>
      </b-col>
      <b-col class="page-background-gradient reduce-padding" cols="12">
        <b-row class="page-content no-gutters">
          <b-row class="body-sec no-gutters">
            <b-row class="summary-box no-gutters">
              <b-col class="reduce-padding" cols="12">
                <b-row class="no-gutters upper-section">
                  <b-col class="reduce-padding" cols="12">
                    <b-row class="no-gutters">
                      <b-col class="reduce-padding" cols="12">
                        <div
                          class="Risk-top-text"
                          :class="{ 'Risk-top-text-sp': $i18n.locale == 'sp' }"
                        >
                          {{ $t("summary.summary2Title") }}
                        </div>
                      </b-col>
                    </b-row>
                    <b-row class="no-gutters">
                      <!--buttons column-->
                      <b-col
                        class="reduce-padding risk-reduction-section"
                        lg="6"
                        cols="12"
                      >
                        <b-row class="left-box no-gutters">
                          <b-col class="reduce-padding" cols="12">
                            <b-row class="no-gutters">
                              <!--HLP-->
                              <b-col
                                class="reduce-padding"
                                lg="8"
                                md="9"
                                sm="9"
                                cols="7"
                              >
                                <b-row class="no-gutters">
                                  <b-col class="reduce-padding" cols="12">
                                    <div class="risk-box">
                                      <div class="hyperlipidemia-icon"></div>
                                      <div class="image-text">Dyslipidemia</div>
                                    </div>
                                  </b-col>
                                </b-row>
                              </b-col>
                              <b-col
                                class="align-right reduce-padding"
                                lg="4"
                                md="3"
                                sm="3"
                                cols="5"
                              >
                                <button
                                  v-if="userData.conditions.hyplip"
                                  class="view-graph-btn"
                                  @click="updateButtons('hlp')"
                                  :class="{ clicked: view.hlp }"
                                >
                                  {{ $t("summary.viewGraph") }}
                                </button>
                                <button
                                  v-if="!userData.conditions.hyplip"
                                  class="view-graph-btn grey-out"
                                >
                                  {{ $t("summary.viewGraph") }}
                                </button>
                              </b-col>
                              <hr />
                              <!--HTN-->
                              <b-col
                                class="reduce-padding"
                                lg="8"
                                md="9"
                                sm="9"
                                cols="7"
                              >
                                <b-row class="no-gutters">
                                  <b-col class="reduce-padding" cols="12">
                                    <div class="risk-box">
                                      <div class="hypertension-icon"></div>
                                      <div class="image-text">
                                        {{ $t("common.hypertension") }}
                                      </div>
                                    </div>
                                  </b-col>
                                </b-row>
                              </b-col>
                              <b-col
                                class="align-right reduce-padding"
                                lg="4"
                                md="3"
                                sm="3"
                                cols="5"
                              >
                                <button
                                  v-if="userData.conditions.hypten"
                                  class="view-graph-btn"
                                  @click="updateButtons('htn')"
                                  :class="{ clicked: view.htn }"
                                >
                                  {{ $t("summary.viewGraph") }}
                                </button>
                                <button
                                  v-if="!userData.conditions.hypten"
                                  class="view-graph-btn grey-out"
                                >
                                  {{ $t("summary.viewGraph") }}
                                </button>
                              </b-col>
                              <hr />
                              <!--INFERTILITY-->
                              <b-col
                                class="reduce-padding"
                                lg="8"
                                md="9"
                                sm="9"
                                cols="7"
                              >
                                <b-row class="no-gutters">
                                  <b-col class="reduce-padding" cols="12">
                                    <div
                                      class="risk-box"
                                      :class="{
                                        'opacity-div':
                                          userData.gender == 'Male',
                                      }"
                                    >
                                      <div class="infertility-icon"></div>
                                      <div class="image-text">
                                        <div v-if="$i18n.locale == 'sp'">
                                          {{ $t("common.infertility") }}
                                          <span class="normal-text"
                                            >(PCOS)</span
                                          >
                                        </div>
                                        <div v-if="$i18n.locale == 'en'">
                                          Infertility (PCOS)
                                        </div>
                                      </div>
                                    </div>
                                  </b-col>
                                </b-row>
                              </b-col>
                              <b-col
                                class="align-right reduce-padding"
                                lg="4"
                                md="3"
                                sm="3"
                                cols="5"
                              >
                                <button
                                  v-if="
                                    userData.gender !== 'Male' &&
                                    userData.conditions.infertility
                                  "
                                  class="view-graph-btn"
                                  @click="updateButtons('infertility')"
                                  :class="{ clicked: view.infertility }"
                                >
                                  {{ $t("summary.viewGraph") }}
                                </button>
                                <button
                                  v-if="
                                    userData.gender !== 'Male' &&
                                    !userData.conditions.infertility
                                  "
                                  class="view-graph-btn grey-out"
                                >
                                  {{ $t("summary.viewGraph") }}
                                </button>
                                <button
                                  v-if="userData.gender == 'Male'"
                                  class="view-graph-btn disabled-btn"
                                >
                                  {{ $t("summary.viewGraph") }}
                                </button>
                              </b-col>
                              <hr />
                              <!--OA-->
                              <b-col
                                class="reduce-padding"
                                lg="8"
                                md="9"
                                sm="9"
                                cols="7"
                              >
                                <b-row class="no-gutters">
                                  <b-col class="reduce-padding" cols="12">
                                    <div class="risk-box">
                                      <div class="osteoarthritis-icon"></div>
                                      <div class="image-text">
                                        {{ $t("common.osteoarthritis") }}
                                      </div>
                                    </div>
                                  </b-col>
                                </b-row>
                              </b-col>
                              <b-col
                                class="align-right reduce-padding"
                                lg="4"
                                md="3"
                                sm="3"
                                cols="5"
                              >
                                <button
                                  v-if="userData.conditions.osteoarth"
                                  class="view-graph-btn"
                                  @click="updateButtons('oa')"
                                  :class="{ clicked: view.oa }"
                                >
                                  {{ $t("summary.viewGraph") }}
                                </button>
                                <button
                                  v-if="!userData.conditions.osteoarth"
                                  class="view-graph-btn grey-out"
                                >
                                  {{ $t("summary.viewGraph") }}
                                </button>
                              </b-col>
                              <hr />
                              <!--DIAB-->
                              <b-col
                                class="reduce-padding"
                                lg="8"
                                md="9"
                                sm="9"
                                cols="7"
                              >
                                <b-row class="no-gutters">
                                  <b-col class="reduce-padding" cols="12">
                                    <div
                                      class="risk-box type2-box type-2-margin"
                                    >
                                      <div class="type2-icon"></div>
                                      <div class="image-text">
                                        {{ $t("common.diabetes") }}
                                      </div>
                                    </div>
                                  </b-col>
                                </b-row>
                              </b-col>
                              <b-col
                                class="align-right reduce-padding"
                                lg="4"
                                md="3"
                                sm="3"
                                cols="5"
                              >
                                <button
                                  v-if="userData.conditions.diab"
                                  class="view-graph-btn"
                                  @click="updateButtons('diab')"
                                  :class="{ clicked: view.diab }"
                                >
                                  {{ $t("summary.viewGraph") }}
                                </button>
                                <button
                                  v-if="!userData.conditions.diab"
                                  class="view-graph-btn grey-out"
                                >
                                  {{ $t("summary.viewGraph") }}
                                </button>
                              </b-col>
                            </b-row>
                          </b-col>
                        </b-row>
                      </b-col>

                      <!--graph column-->
                      <b-col
                        class="reduce-padding lower-bmi-section"
                        lg="6"
                        cols="12"
                      >
                        <b-row class="no-gutters right-box">
                          <b-col class="reduce-padding" cols="12">
                            <!--BAR GRAPH BOX-->
                            <b-row
                              class="no-gutters bar-graph-box"
                              :class="{
                                'bar-graph-boxsm': !view.hlp && !view.htn,
                              }"
                            >
                              <!--HLP-->
                              <b-col
                                class="reduce-padding"
                                cols="12"
                                v-if="view.hlp"
                              >
                                <div class="Bmi-top-text">
                                  10% {{ $t("summary.lower") }} ({{
                                    $t("common.bmi")
                                  }}
                                  - {{ userData.calc.bmi.adj10 }})
                                </div>
                                <b-row class="graph-top-txt no-gutters">
                                  <div class="current-txt bold-txt">
                                    {{
                                      $t("graph.bargraph-title-dyslipidemia")
                                    }}
                                  </div>
                                  <div class="current-txt">
                                    10% {{ $t("summary.lower") }}
                                    {{ $t("common.weight") }} (mg/dL)
                                  </div>
                                </b-row>
                                <b-row class="no-gutters">
                                  <b-col class="reduce-padding" cols="12">
                                    <div class="bar-graph-div">
                                      <barGraph
                                        :disease="'hyplip'"
                                        :barValues="userData.calc.hyplip"
                                        :adjustSelection="10"
                                        :isSummary="true"
                                        :displayBars="
                                          userData.trigs >= 90 &&
                                          userData.hdl >= 20 &&
                                          userData.hdl <= 100
                                        "
                                        :displayGraph="displayBarGraph"
                                        :lblY="lblYdyslipidemia"
                                        :lblEndX="300"
                                        :lblStartX="0"
                                        :lblSkipX="20"
                                      ></barGraph>
                                    </div>
                                  </b-col>
                                </b-row>
                              </b-col>
                              <!--HTN-->
                              <b-col
                                class="reduce-padding"
                                cols="12"
                                v-if="view.htn"
                              >
                                <div class="Bmi-top-text">
                                  5% {{ $t("summary.lower") }} ({{
                                    $t("common.bmi")
                                  }}
                                  - {{ userData.calc.bmi.adj5 }})
                                </div>
                                <b-row class="graph-top-txt no-gutters">
                                  <div class="current-txt bold-txt">
                                    {{
                                      $t("graph.bargraph-title-hypertension")
                                    }}
                                  </div>
                                  <div class="current-txt">
                                    5% {{ $t("summary.lower") }}
                                    {{ $t("common.weight") }} (mm Hg)
                                  </div>
                                </b-row>
                                <b-row class="no-gutters">
                                  <b-col class="reduce-padding" cols="12">
                                    <div class="bar-graph-div">
                                      <barGraph
                                        :disease="'hypten'"
                                        :barValues="userData.calc.hyptenBP"
                                        :adjustSelection="5"
                                        :isSummary="true"
                                        :displayBars="
                                          this.userData.systolicBp >= 90 &&
                                          this.userData.systolicBp < 300 &&
                                          this.userData.diastolicBp >= 50 &&
                                          this.userData.diastolicBp < 200 &&
                                          this.userData.diastolicBp <=
                                            this.userData.systolicBp
                                        "
                                        :displayGraph="displayBarGraph"
                                        :lblY="lblYhypertension"
                                        :lblEndX="200"
                                        :lblStartX="50"
                                        :lblSkipX="10"
                                      ></barGraph>
                                    </div>
                                  </b-col>
                                </b-row>
                              </b-col>
                              <!--PCOS-->
                              <b-col
                                class="reduce-padding"
                                cols="12"
                                v-if="
                                  view.infertility &&
                                  userData.gender == 'Female'
                                "
                              >
                                <div class="Bmi-top-text">
                                  10% {{ $t("summary.lower") }} ({{
                                    $t("common.bmi")
                                  }}
                                  - {{ userData.calc.bmi.adj10 }})
                                </div>
                                <b-row class="graph-top-txt no-gutters">
                                  <div class="current-txt bold-txt">
                                    {{ $t("graph.bargraph-title-pcos") }}
                                  </div>
                                  <div class="current-txt">
                                    10% {{ $t("summary.lower") }}
                                    {{ $t("common.weight") }} (%)
                                  </div>
                                </b-row>
                                <b-row class="no-gutters">
                                  <b-col class="reduce-padding" cols="12">
                                    <div class="bar-graph-div">
                                      <barGraph
                                        :disease="'pcos'"
                                        :barValues="userData.calc.pcosRegain"
                                        :adjustSelection="10"
                                        :displayBars="true"
                                        :isSummary="true"
                                        :displayGraph="displayBarGraph"
                                        :lblY="lblYbmi"
                                        :lblEndX="100"
                                        :lblStartX="0"
                                        :lblSkipX="25"
                                      ></barGraph>
                                    </div>
                                  </b-col>
                                </b-row>
                              </b-col>
                              <!--OA-->
                              <b-col
                                class="reduce-padding"
                                cols="12"
                                v-if="view.oa"
                              >
                                <div class="Bmi-top-text">
                                  10% {{ $t("summary.lower") }} ({{
                                    $t("common.bmi")
                                  }}
                                  - {{ userData.calc.bmi.adj10 }})
                                </div>
                                <b-row class="graph-top-txt no-gutters">
                                  <div class="current-txt bold-txt">
                                    {{
                                      $t("graph.bargraph-title-osteoarthritis")
                                    }}
                                  </div>
                                  <div class="current-txt">
                                    10% {{ $t("summary.lower") }}
                                    {{ $t("common.weight") }} (%)
                                  </div>
                                </b-row>
                                <b-row class="no-gutters">
                                  <b-col class="reduce-padding" cols="12">
                                    <div class="bar-graph-div">
                                      <barGraph
                                        :disease="'oa'"
                                        :barValues="userData.calc.oaReduction"
                                        :adjustSelection="10"
                                        :displayBars="true"
                                        :isSummary="true"
                                        :displayGraph="displayBarGraph"
                                        :lblEndX="50"
                                        :lblStartX="0"
                                        :lblSkipX="5"
                                      ></barGraph>
                                    </div>
                                  </b-col>
                                </b-row>
                              </b-col>
                              <!--DIAB-->
                              <b-col
                                class="reduce-padding"
                                cols="12"
                                v-if="view.diab"
                              >
                                <div class="Bmi-top-text">
                                  10% {{ $t("summary.lower") }} ({{
                                    $t("common.bmi")
                                  }}
                                  - {{ userData.calc.bmi.adj10 }})
                                </div>
                                <b-row
                                  class="graph-top-txt no-gutters"
                                  :class="{
                                    'graph-top-txt-sp': $i18n.locale == 'sp',
                                  }"
                                >
                                  <div class="current-txt bold-txt">
                                    {{ $t("graph.bargraph-title-a1c") }}
                                  </div>
                                  <div class="current-txt">
                                    10% {{ $t("summary.lower") }}
                                    {{ $t("common.weight") }} (%)
                                  </div>
                                </b-row>
                                <b-row class="no-gutters">
                                  <b-col class="reduce-padding" cols="12">
                                    <div class="bar-graph-div">
                                      <barGraph
                                        :disease="'diab'"
                                        :barValues="userData.calc.diabA1c"
                                        :adjustSelection="10"
                                        :isSummary="true"
                                        :displayBars="
                                          parseFloat(userData.diab) > 4 &&
                                          parseFloat(userData.diab) < 15
                                        "
                                        :displayGraph="displayBarGraph"
                                        :lblEndX="14"
                                        :lblStartX="4"
                                        :lblSkipX="1"
                                      ></barGraph>
                                    </div>
                                  </b-col>
                                </b-row>
                              </b-col>
                            </b-row>
                            <b-row
                              class="no-gutters graph-legends"
                              v-show="
                                view.hlp +
                                view.htn +
                                view.infertility +
                                view.oa +
                                view.diab
                              "
                            >
                              <!--Graph Legends-->
                              <b-col class="reduce-padding" cols="12">
                                <div
                                  class="bottom-section"
                                  :class="{
                                    'bottom-section-sp': $i18n.locale == 'sp',
                                  }"
                                >
                                  <div class="weight-loss-txt before-loss">
                                    <div class="bullet blue"></div>
                                    <div
                                      class="bullet-text"
                                      :class="{
                                        'bullet-text-sp': $i18n.locale == 'sp',
                                      }"
                                    >
                                      {{ $t("common.beforeWeight") }}
                                    </div>
                                  </div>
                                  <div class="weight-loss-txt after-loss">
                                    <div class="bullet green"></div>
                                    <div
                                      class="bullet-text"
                                      :class="{
                                        'bullet-text-sp': $i18n.locale == 'sp',
                                      }"
                                    >
                                      {{ $t("common.afterWeight") }}
                                    </div>
                                  </div>
                                </div>
                                <div class="footer-text">
                                  <i
                                    ><sup>*</sup
                                    >{{ $t("summary.footer-text") }}</i
                                  >
                                </div>
                              </b-col>
                            </b-row>
                          </b-col>
                        </b-row>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
              </b-col>
              <b-col class="reduce-padding" cols="12">
                <!--email pdf section-->
                <b-row class="print-out-section no-gutters">
                  <b-col class="lower-section reduce-padding" cols="12">
                    <b-row class="no-gutters">
                      <b-col class="top-space reduce-padding" lg="7" cols="12">
                        <b-row class="no-gutters">
                          <b-col class="reduce-padding" cols="12">
                            <b-row class="no-gutters">
                              <b-col class="reduce-padding" lg="6" cols="12">
                                <div
                                  class="view-heading-txt"
                                  :class="{
                                    'view-heading-txt-sp': $i18n.locale == 'sp',
                                  }"
                                >
                                  1. {{ $t("summary.viewReport") }}
                                </div>
                                <div
                                  class="View-txt"
                                  :class="{
                                    'View-txt-sp': $i18n.locale == 'sp',
                                  }"
                                >
                                  {{ $t("summary.reportDetail") }}
                                </div>
                              </b-col>
                              <b-col class="reduce-padding" lg="6" cols="12">
                                <div class="view-btn">
                                  <button
                                    v-if="!generatingViewPdf && !pdfViewReady"
                                    class="viewReport-btn"
                                    @click="generateViewPdf(userData)"
                                  ></button>
                                  <b-button
                                    class="pdf-button spinner-btn btn2-gen"
                                    v-if="generatingViewPdf"
                                    disabled
                                  >
                                    <div class="topgenbtn">
                                      <b-spinner small></b-spinner> Generating
                                      Report...
                                    </div>
                                  </b-button>
                                  <button
                                    class="pdf-button btn2-gen"
                                    v-if="pdfViewReady && !generatingViewPdf"
                                    @click="viewPDF()"
                                  >
                                    <div class="topgenbtn">
                                      Click to view now
                                    </div>
                                  </button>
                                </div>
                                <div class="save-btn">
                                  <button
                                    v-if="!generatingPdf && !pdfReady"
                                    class="saveReport-btn"
                                    @click="generatePdf(userData)"
                                  ></button>
                                  <b-button
                                    class="pdf-button spinner-btn"
                                    v-if="generatingPdf"
                                    disabled
                                  >
                                    <b-spinner small></b-spinner> Generating
                                    Report...
                                  </b-button>
                                  <button
                                    class="pdf-button"
                                    v-if="pdfReady && !generatingPdf"
                                    @click="downloadaPdf()"
                                  >
                                    DOWNLOAD REPORT
                                  </button>
                                </div>
                                <div class="vertical-line"></div>
                              </b-col>
                            </b-row>
                          </b-col>
                        </b-row>
                      </b-col>
                      <b-col class="top-space reduce-padding" lg="5" cols="12">
                        <b-row class="no-gutters">
                          <b-col class="reduce-padding" cols="12">
                            <b-row class="no-gutters">
                              <b-col
                                class="reduce-padding"
                                lg="9"
                                md="10"
                                sm="9"
                                cols="9"
                              >
                                <div
                                  class="share-heading-txt"
                                  :class="{
                                    'share-heading-txt-sp':
                                      $i18n.locale == 'sp',
                                  }"
                                >
                                  2. {{ $t("summary.shareTool1") }}
                                </div>
                                <div class="share-txt">
                                  {{ $t("summary.shareTool2") }}
                                </div>
                                <div
                                  class="result-txt"
                                  :class="{
                                    'result-txt-sp': $i18n.locale == 'sp',
                                  }"
                                >
                                  <i>({{ $t("summary.shareTool3") }})</i>
                                </div>
                              </b-col>
                              <b-col
                                class="reduce-padding"
                                lg="3"
                                md="2"
                                sm="3"
                                cols="3"
                              >
                                <div
                                  @click="$router.push('email')"
                                  class="mail-img"
                                ></div>
                              </b-col>
                            </b-row>
                          </b-col>
                        </b-row>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-row>
        </b-row>
        <wlpNavigation
          :navButtons="['info', 'references', 'tnc', 'back', 'menu2']"
          :currentScreen="11"
          :btn3Absent="true"
          :btn4Absent="true"
        ></wlpNavigation>
      </b-col>
    </b-col>
  </b-row>
</template>
<script>
/* eslint-disable */
import scrollMixin from "../mixins/scrollMixin";
import wlpHeader from "../components/wlpHeader.vue";
import wlpNavigation from "../components/wlpNavigation.vue";
import barGraph from "../components/barGraph.vue";
import LZString from "lz-string";
import axios from "axios";
import { mapGetters } from "vuex";

export default {
  name: "summary2",
  mixins: [scrollMixin],
  mounted: function () {
    this.scrollToTop();
  },
  components: {
    wlpHeader: wlpHeader,
    wlpNavigation: wlpNavigation,
    barGraph: barGraph,
  },

  computed: {
    ...mapGetters("userData", ["userData"]),
  },
  data() {
    return {
      pageTitle: this.$t("summary.pageTitle"),
      generatingPdf: false,
      pdfReady: false,
      generatingViewPdf: false,
      pdfViewReady: false,
      view: {
        hlp: false,
        htn: false,
        infertility: false,
        oa: false,
        diab: false,
      },
      displayBarGraph: false,
      lblYbmi: [this.$t("common.bmi"), this.$t("common.bmi")],
      lblYhypertension: [
        this.$t("hypertension.ylabel1"),
        this.$t("hypertension.ylabel2"),
      ],
      lblYdyslipidemia: [
        this.$t("dyslipidemia.ylabel1"),
        this.$t("dyslipidemia.ylabel2"),
      ],
    };
  },

  methods: {
    generatePdf: function (userData) {
      this.generatingPdf = true;
      const config = this.$config.config;
      const data = LZString.compressToEncodedURIComponent(
        JSON.stringify(userData)
      );

      // if a URL was given in the config use that otherwise create it based on the current location
      var reportUrl = "";
      if (this.$config.reportUrl !== undefined) {
        reportUrl = "{0}#?u={1}".format(this.$config.reportUrl);
      } else {
        const url = window.location.href;
        const parts = url.split("://");
        const schema = parts[0];
        const uri = parts[1].replace(/#.*$/, "").replace(/\/[^\/]*$/, "");
        if (this.$i18n.locale == "en") {
          reportUrl = `${schema}://${uri}/report.html#?u=${data}`;
        } else if (this.$i18n.locale == "sp") {
          reportUrl = `${schema}://${uri}/report-sp.html#?u=${data}`;
        }
      }
      console.log(reportUrl);
      const renderConfig = {
        url: reportUrl,
        paper_size: {
          width: 8.5,
          height: 11,
        },
        margin: {
          top: 0.5,
          bottom: 0.02,
          left: 0.02,
          right: 0.02,
        },
        print_background: true,
      };

      axios
        .post(`${config.serviceUrl2}/v1/render`, renderConfig)
        .then((response) => {
          this.generatingPdf = false;
          this.pdfReady = true;
          this.key = response.data.result;
        })
        .catch((error) => {
          this.generatingPdf = false;
          alert(`Error generating PDF. ${error}`);
        });
    },

    downloadaPdf: function () {
      const config = this.$config.config;

      window.open(
        `${config.serviceUrl2}/v1/render/${this.key}?filename=report.pdf&save=true`,
        "_blank"
      );

      this.pdfReady = false;
    },
    generateViewPdf: function (userData) {
      this.generatingViewPdf = true;
      const config = this.$config.config;
      const data = LZString.compressToEncodedURIComponent(
        JSON.stringify(userData)
      );

      // if a URL was given in the config use that otherwise create it based on the current location
      var reportUrl = "";
      if (this.$config.reportUrl !== undefined) {
        reportUrl = "{0}#?u={1}".format(this.$config.reportUrl);
      } else {
        const url = window.location.href;
        const parts = url.split("://");
        const schema = parts[0];
        const uri = parts[1].replace(/#.*$/, "").replace(/\/[^\/]*$/, "");
        if (this.$i18n.locale == "en") {
          reportUrl = `${schema}://${uri}/report.html#?u=${data}`;
        }
        if (this.$i18n.locale == "sp") {
          reportUrl = `${schema}://${uri}/report-sp.html#?u=${data}`;
        }
      }
      console.log(reportUrl);
      const renderConfig = {
        url: reportUrl,
        paper_size: {
          width: 8.5,
          height: 11,
        },
        margin: {
          top: 0.8,
          bottom: 0.0,
          left: 0.02,
          right: 0.05,
        },
        print_background: true,
      };
      axios
        .post(`${config.serviceUrl2}/v1/render`, renderConfig)
        .then((response) => {
          this.generatingViewPdf = false;
          this.pdfViewReady = true;
          this.key = response.data.result;
        })
        .catch((error) => {
          this.generatingViewPdf = false;
          alert(`Error generating PDF. ${error}`);
        });
    },
    viewPDF: function () {
      const config = this.$config.config;
      window.open(`${config.serviceUrl2}/v1/render/${this.key}`, "_blank");
      this.pdfViewReady = false;
    },

    updateButtons: function (flag) {
      this.view = {
        hlp: false,
        htn: false,
        infertility: false,
        oa: false,
        diab: false,
      };
      this.view[flag] = true;
      // this.displayBarGraph=true;
      this.displayBarGraph = !this.displayBarGraph;
    },
  },
};
</script>


<style lang="scss" scoped>
</style>
